<template>
  <v-dialog v-model="previewDialog" max-width="800" lazy>
    <template v-slot:activator="{ on }">
      <div v-on="on">
        <v-btn fab flat class="mx-3">
          <v-avatar>
            <v-icon :class="bg" medium color="white">fas fa-file-video</v-icon>
          </v-avatar>
        </v-btn>
      </div>
      <div>
        <div v-if="shadowFile.description">
          <p class="ma-0">
            <a v-on="on" class="fileName">{{shadowFile.name |truncate(40)}}</a>
          </p>
          <p class="mb-1 fileDescription">{{shadowFile.description}}</p>
        </div>
        <div v-else align-center fill-height>
          <p class="ma-0">
            <a v-on="on" class="fileName">{{shadowFile.name |truncate(40)}}</a>
          </p>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div align-center>
        <slot></slot>
      </div>
    </template>

    <v-card>
      <v-card-title>
        <h3>{{shadowFile.name}}</h3>
        <v-spacer/>
        <v-btn color="blue darken-1" flat outline @click="closePreview()">Close</v-btn>
      </v-card-title>
      <v-card-text>
        <amaze-video-player :source="filepath" ref="previewPlayer"></amaze-video-player>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.userfile {
  width: 100%;
  font-size: 16px;
  background-color: #f9f5f1;
}
.fileName {
  font-weight: bold;
  font-size: 16px;
}
.fileDescription {
  font-size: 14px;
}
.time {
  font-size: 12px;
}
</style>
<script>

import AmazeVideoPlayer from "@/components/Widgets/AmazeVideoPlayer";

export default {
  components: { AmazeVideoPlayer },
  props: ["userfile"],
  data() {
    return {
      previewDialog: false,
      shadowFile: this.userfile
    };
  },
  computed: {
    bg() {
      return "pa-2 cyan darker-1";
    },
    filepath() {
      return process.env.VUE_APP_FILE_BASE + this.userfile.full_url;
    }
  },
  methods: {
    previewFile() {
      this.previewDialog = true;
    },
    closePreview() {
      var previewPlayer = this.$refs.previewPlayer;
      previewPlayer.pausePlayer();
      this.previewDialog = false;
    }
  }
};
</script>
